var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 215 59",
    style: {
      enableBackground: "new 0 0 215 59"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1C3664;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_17_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_170_",
    className: "st0",
    points: "23,17 23,10.5 0.3,10.5 0.3,42.5 23,42.4 23,35.9 6.8,35.9 6.8,17  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_40_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_169_",
    className: "st0",
    d: "M49.1,42.5L34.6,25l4.2,0h5c3,0,4.3-2.1,4.3-4.1c0-2-1.3-4-4.3-4H32.3v25.5h-6.4v-32h17.9 c7,0,10.7,5.3,10.7,10.5c0,3.8-2.1,8.1-6.8,9.7l9.7,11.8H49.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_24_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_20_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_168_",
    x: 70.4,
    y: 23.2,
    className: "st0",
    width: 8.6,
    height: 6.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_18_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_42_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_167_",
    className: "st0",
    points: "60.2,10.5 60.2,23.3 66.7,23.3 66.7,17 83.4,17 83.4,10.5  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_43_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_166_",
    className: "st0",
    points: "66.7,29.7 60.2,29.7 60.2,42.5 83.4,42.5 83.4,35.9 66.7,35.9  "
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_23_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_30_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_165_",
    x: 194.1,
    y: 23.2,
    className: "st0",
    width: 8.6,
    height: 6.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_27_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_29_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_164_",
    className: "st0",
    points: "183.8,10.5 183.8,23.3 190.3,23.3 190.3,17 207,17 207,10.5  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_28_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_163_",
    className: "st0",
    points: "190.3,29.7 183.8,29.7 183.8,42.5 207,42.5 207,35.9 190.3,35.9  "
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_61_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_162_",
    className: "st0",
    points: "117.2,42.5 110,42.5 101.8,23.7 93.3,42.5 86.2,42.5 99.2,15.7 101.8,10.5  104.3,15.7  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_13_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_161_",
    className: "st0",
    points: "181.1,10.5 174.5,10.5 165.6,30.2 156.5,10.5 150.1,10.5 163.1,37.2 165.6,42.4  168.2,37.2  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_33_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_160_",
    className: "st0",
    points: "137.9,10.5 137.9,17 128.4,17 128.4,42.5 121.8,42.5 121.8,17 112.4,17 112.4,10.5  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_12_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_159_",
    x: 140.9,
    y: 10.5,
    className: "st0",
    width: 6.5,
    height: 32
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_6_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_7_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2_",
    x: 0.3,
    y: 45.8,
    className: "st0",
    width: 206.8,
    height: 1.7
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_14_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_103_",
    className: "st0",
    d: "M7.3,54.9c0,0.6-0.1,1.1-0.3,1.6c-0.2,0.5-0.5,0.9-0.8,1.3c-0.4,0.4-0.8,0.6-1.3,0.8 c-0.5,0.2-1.1,0.3-1.7,0.3H0v-8.1h3.1c0.6,0,1.2,0.1,1.7,0.3c0.5,0.2,1,0.5,1.3,0.8c0.4,0.4,0.6,0.8,0.8,1.3 C7.2,53.8,7.3,54.3,7.3,54.9z M5.4,54.9c0-0.4-0.1-0.8-0.2-1.1C5.1,53.5,5,53.2,4.8,53c-0.2-0.2-0.4-0.4-0.7-0.5 c-0.3-0.1-0.6-0.2-1-0.2H1.9v5.2h1.2c0.4,0,0.7-0.1,1-0.2c0.3-0.1,0.5-0.3,0.7-0.5C5,56.6,5.1,56.3,5.2,56 C5.3,55.6,5.4,55.3,5.4,54.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_106_",
    className: "st0",
    d: "M14.4,50.9v1.4h-3.3v1.9h2.5v1.4h-2.5v1.9h3.3v1.4H9.2v-8.1H14.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_108_",
    className: "st0",
    d: "M20.9,52.5c-0.1,0.1-0.1,0.2-0.2,0.2c-0.1,0-0.1,0.1-0.2,0.1c-0.1,0-0.2,0-0.3-0.1 c-0.1-0.1-0.2-0.1-0.3-0.2c-0.1-0.1-0.3-0.1-0.4-0.2c-0.2-0.1-0.3-0.1-0.5-0.1c-0.3,0-0.6,0.1-0.8,0.2c-0.2,0.1-0.3,0.4-0.3,0.6 c0,0.2,0.1,0.3,0.2,0.4c0.1,0.1,0.2,0.2,0.4,0.3c0.2,0.1,0.4,0.1,0.6,0.2c0.2,0.1,0.4,0.1,0.7,0.2c0.2,0.1,0.4,0.2,0.7,0.3 c0.2,0.1,0.4,0.2,0.6,0.4c0.2,0.2,0.3,0.4,0.4,0.6c0.1,0.2,0.2,0.5,0.2,0.9c0,0.4-0.1,0.7-0.2,1c-0.1,0.3-0.3,0.6-0.6,0.8 c-0.2,0.2-0.5,0.4-0.9,0.6c-0.4,0.1-0.8,0.2-1.2,0.2c-0.3,0-0.5,0-0.8-0.1c-0.3-0.1-0.5-0.1-0.8-0.2c-0.2-0.1-0.5-0.2-0.7-0.3 c-0.2-0.1-0.4-0.3-0.6-0.4l0.6-0.9c0-0.1,0.1-0.1,0.2-0.2c0.1,0,0.2-0.1,0.2-0.1c0.1,0,0.2,0,0.3,0.1c0.1,0.1,0.2,0.1,0.4,0.2 c0.1,0.1,0.3,0.2,0.5,0.2s0.4,0.1,0.7,0.1c0.3,0,0.6-0.1,0.8-0.2c0.2-0.1,0.3-0.4,0.3-0.7c0-0.2-0.1-0.3-0.2-0.5 c-0.1-0.1-0.2-0.2-0.4-0.3c-0.2-0.1-0.4-0.1-0.6-0.2s-0.4-0.1-0.7-0.2c-0.2-0.1-0.4-0.2-0.7-0.3c-0.2-0.1-0.4-0.2-0.6-0.4 c-0.2-0.2-0.3-0.4-0.4-0.6c-0.1-0.3-0.2-0.6-0.2-0.9c0-0.3,0.1-0.6,0.2-0.9c0.1-0.3,0.3-0.5,0.5-0.8c0.2-0.2,0.5-0.4,0.9-0.5 c0.3-0.1,0.7-0.2,1.2-0.2c0.2,0,0.5,0,0.7,0.1c0.2,0,0.5,0.1,0.7,0.2c0.2,0.1,0.4,0.2,0.6,0.3c0.2,0.1,0.3,0.2,0.5,0.4L20.9,52.5z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_110_",
    className: "st0",
    d: "M25.4,58.9h-1.9v-8.1h1.9V58.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_112_",
    className: "st0",
    d: "M31.7,57.6c0.3,0,0.5,0,0.7-0.1c0.2,0,0.4-0.1,0.6-0.2v-1.2h-0.8c-0.1,0-0.2,0-0.3-0.1 c-0.1-0.1-0.1-0.1-0.1-0.2v-1h2.9v3.4c-0.2,0.2-0.4,0.3-0.6,0.4c-0.2,0.1-0.5,0.2-0.7,0.3c-0.3,0.1-0.5,0.1-0.8,0.2s-0.6,0-0.9,0 c-0.6,0-1.1-0.1-1.6-0.3c-0.5-0.2-0.9-0.5-1.3-0.9c-0.4-0.4-0.7-0.8-0.9-1.3c-0.2-0.5-0.3-1-0.3-1.6c0-0.6,0.1-1.2,0.3-1.7 c0.2-0.5,0.5-0.9,0.9-1.3c0.4-0.4,0.8-0.6,1.3-0.9c0.5-0.2,1.1-0.3,1.8-0.3c0.3,0,0.6,0,0.9,0.1c0.3,0.1,0.6,0.1,0.8,0.2 c0.2,0.1,0.5,0.2,0.7,0.3c0.2,0.1,0.4,0.3,0.6,0.4l-0.5,0.8c-0.1,0.1-0.1,0.1-0.2,0.2c-0.1,0-0.1,0.1-0.2,0.1 c-0.1,0-0.2,0-0.3-0.1c-0.1-0.1-0.3-0.2-0.4-0.2c-0.1-0.1-0.3-0.1-0.4-0.2c-0.1,0-0.3-0.1-0.4-0.1c-0.2,0-0.3,0-0.5,0 c-0.3,0-0.7,0.1-0.9,0.2c-0.3,0.1-0.5,0.3-0.7,0.5c-0.2,0.2-0.3,0.5-0.5,0.8c-0.1,0.3-0.2,0.7-0.2,1.1c0,0.4,0.1,0.8,0.2,1.1 c0.1,0.3,0.3,0.6,0.5,0.8c0.2,0.2,0.5,0.4,0.7,0.5C31.1,57.5,31.4,57.6,31.7,57.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_114_",
    className: "st0",
    d: "M38,50.9c0.1,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0.1c0,0,0.1,0.1,0.1,0.1l3.8,4.8 c0-0.2,0-0.3,0-0.5c0-0.1,0-0.3,0-0.4v-4.3h1.6v8.1h-1c-0.1,0-0.3,0-0.4-0.1c-0.1,0-0.2-0.1-0.3-0.2l-3.8-4.8c0,0.1,0,0.3,0,0.4 c0,0.1,0,0.3,0,0.4v4.3h-1.6v-8.1h1C37.8,50.9,37.9,50.9,38,50.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_116_",
    className: "st0",
    d: "M52.3,50.8c0.4,0,0.7,0.1,0.9,0.2c0.3,0.1,0.5,0.2,0.7,0.4c0.2,0.2,0.3,0.4,0.4,0.6 c0.1,0.2,0.2,0.5,0.2,0.7l-1.1,0.2c0,0,0,0,0,0c0,0,0,0,0,0c-0.2,0-0.3-0.1-0.3-0.2c-0.1-0.2-0.2-0.3-0.3-0.4 c-0.1-0.1-0.3-0.1-0.4-0.1c-0.1,0-0.2,0-0.3,0.1c-0.1,0-0.2,0.1-0.2,0.2c-0.1,0.1-0.1,0.2-0.1,0.3c0,0.1,0,0.2,0,0.3 c0,0.1,0,0.2,0,0.3c0,0.1,0,0.2,0.1,0.3c0,0.1,0.1,0.2,0.2,0.3c0.1,0.1,0.2,0.2,0.3,0.3l2,2.1c0.1-0.2,0.2-0.5,0.2-0.7 c0.1-0.2,0.1-0.5,0.1-0.7c0-0.1,0-0.2,0.1-0.2c0.1-0.1,0.1-0.1,0.2-0.1h1.1c0,0.5-0.1,1-0.2,1.5c-0.1,0.5-0.3,0.9-0.6,1.3l1.7,1.8 H55c-0.1,0-0.2,0-0.2,0c-0.1,0-0.1,0-0.2,0c-0.1,0-0.1-0.1-0.2-0.1c-0.1,0-0.1-0.1-0.2-0.2l-0.3-0.4c-0.3,0.2-0.7,0.4-1.1,0.6 c-0.4,0.1-0.9,0.2-1.3,0.2c-0.3,0-0.6-0.1-0.9-0.2c-0.3-0.1-0.6-0.3-0.8-0.5c-0.2-0.2-0.4-0.5-0.6-0.7c-0.1-0.3-0.2-0.6-0.2-1 c0-0.2,0-0.5,0.1-0.7c0.1-0.2,0.2-0.4,0.3-0.6c0.1-0.2,0.3-0.4,0.5-0.5c0.2-0.2,0.4-0.3,0.6-0.4c-0.2-0.3-0.3-0.5-0.4-0.8 c-0.1-0.3-0.1-0.5-0.1-0.8c0-0.3,0.1-0.6,0.2-0.8c0.1-0.3,0.3-0.5,0.5-0.7c0.2-0.2,0.4-0.3,0.7-0.5C51.5,50.8,51.9,50.8,52.3,50.8 z M50.6,56.5c0,0.2,0,0.3,0.1,0.5s0.1,0.3,0.2,0.4c0.1,0.1,0.2,0.2,0.4,0.2c0.1,0.1,0.3,0.1,0.5,0.1c0.2,0,0.5,0,0.7-0.1 c0.2-0.1,0.4-0.2,0.6-0.3l-1.8-2c-0.2,0.2-0.3,0.3-0.4,0.5S50.6,56.3,50.6,56.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_119_",
    className: "st0",
    d: "M65.7,55.7c0.1,0.2,0.1,0.3,0.2,0.5c0.1-0.2,0.1-0.3,0.2-0.5c0.1-0.2,0.1-0.3,0.2-0.4 l2.1-4.1c0-0.1,0.1-0.1,0.1-0.2c0,0,0.1-0.1,0.1-0.1c0,0,0.1,0,0.2,0c0.1,0,0.1,0,0.2,0h1.4v8h-1.6v-4.6c0-0.2,0-0.5,0-0.7 l-2.1,4.1c-0.1,0.1-0.2,0.2-0.3,0.3c-0.1,0.1-0.2,0.1-0.4,0.1h-0.3c-0.1,0-0.3,0-0.4-0.1c-0.1-0.1-0.2-0.2-0.3-0.3L63,53.5 c0,0.1,0,0.3,0,0.4c0,0.1,0,0.2,0,0.4v4.6h-1.6v-8h1.4c0.1,0,0.2,0,0.2,0c0.1,0,0.1,0,0.2,0c0,0,0.1,0,0.1,0.1 c0,0,0.1,0.1,0.1,0.2l2.1,4.1C65.5,55.4,65.6,55.5,65.7,55.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_121_",
    className: "st0",
    d: "M76.1,57.4c0.3,0,0.5,0,0.7-0.1c0.2-0.1,0.4-0.2,0.5-0.4c0.1-0.2,0.2-0.3,0.3-0.6 c0.1-0.2,0.1-0.5,0.1-0.8v-4.8h1.9v4.8c0,0.5-0.1,0.9-0.2,1.4c-0.2,0.4-0.4,0.8-0.7,1.1c-0.3,0.3-0.7,0.5-1.1,0.7 c-0.4,0.2-0.9,0.2-1.4,0.2c-0.5,0-1-0.1-1.4-0.2c-0.4-0.2-0.8-0.4-1.1-0.7c-0.3-0.3-0.5-0.7-0.7-1.1c-0.2-0.4-0.2-0.9-0.2-1.4 v-4.8h1.9v4.8c0,0.3,0,0.5,0.1,0.8c0.1,0.2,0.2,0.4,0.3,0.6c0.1,0.2,0.3,0.3,0.5,0.4C75.6,57.4,75.8,57.4,76.1,57.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_123_",
    className: "st0",
    d: "M83.6,57.4h3v1.5h-4.8v-8.1h1.9V57.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_125_",
    className: "st0",
    d: "M93.3,50.9v1.5H91v6.6h-1.9v-6.6h-2.3v-1.5H93.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_127_",
    className: "st0",
    d: "M97.1,58.9h-1.9v-8.1h1.9V58.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_129_",
    className: "st0",
    d: "M103.9,55.7c0.1,0.2,0.1,0.3,0.2,0.5c0.1-0.2,0.1-0.3,0.2-0.5c0.1-0.2,0.1-0.3,0.2-0.4 l2.1-4.1c0-0.1,0.1-0.1,0.1-0.2c0,0,0.1-0.1,0.1-0.1c0,0,0.1,0,0.2,0c0.1,0,0.1,0,0.2,0h1.4v8H107v-4.6c0-0.2,0-0.5,0-0.7 l-2.1,4.1c-0.1,0.1-0.2,0.2-0.3,0.3c-0.1,0.1-0.2,0.1-0.4,0.1H104c-0.1,0-0.3,0-0.4-0.1c-0.1-0.1-0.2-0.2-0.3-0.3l-2.1-4.1 c0,0.1,0,0.3,0,0.4c0,0.1,0,0.2,0,0.4v4.6h-1.6v-8h1.4c0.1,0,0.2,0,0.2,0c0.1,0,0.1,0,0.2,0c0,0,0.1,0,0.1,0.1 c0,0,0.1,0.1,0.1,0.2l2.1,4.1C103.8,55.4,103.9,55.5,103.9,55.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_131_",
    className: "st0",
    d: "M116.1,50.9v1.4h-3.3v1.9h2.5v1.4h-2.5v1.9h3.3v1.4H111v-8.1H116.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_133_",
    className: "st0",
    d: "M125.5,54.9c0,0.6-0.1,1.1-0.3,1.6c-0.2,0.5-0.5,0.9-0.8,1.3c-0.4,0.4-0.8,0.6-1.3,0.8 c-0.5,0.2-1.1,0.3-1.7,0.3h-3.1v-8.1h3.1c0.6,0,1.2,0.1,1.7,0.3c0.5,0.2,1,0.5,1.3,0.8c0.4,0.4,0.6,0.8,0.8,1.3 C125.4,53.8,125.5,54.3,125.5,54.9z M123.6,54.9c0-0.4-0.1-0.8-0.2-1.1c-0.1-0.3-0.3-0.6-0.4-0.8c-0.2-0.2-0.4-0.4-0.7-0.5 c-0.3-0.1-0.6-0.2-1-0.2h-1.2v5.2h1.2c0.4,0,0.7-0.1,1-0.2c0.3-0.1,0.5-0.3,0.7-0.5c0.2-0.2,0.3-0.5,0.4-0.8 C123.5,55.6,123.6,55.3,123.6,54.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_136_",
    className: "st0",
    d: "M129.4,58.9h-1.9v-8.1h1.9V58.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_138_",
    className: "st0",
    d: "M139.4,58.9H138c-0.2,0-0.3,0-0.4-0.1c-0.1-0.1-0.2-0.2-0.2-0.3l-0.5-1.4h-3.1l-0.5,1.4 c0,0.1-0.1,0.2-0.2,0.3c-0.1,0.1-0.2,0.1-0.4,0.1h-1.5l3.1-8.1h1.9L139.4,58.9z M134.2,55.8h2.2l-0.7-2.2c0-0.1-0.1-0.3-0.2-0.5 c-0.1-0.2-0.1-0.4-0.2-0.6c-0.1,0.2-0.1,0.4-0.2,0.6c-0.1,0.2-0.1,0.4-0.2,0.5L134.2,55.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_141_",
    className: "st0",
    d: "M146.2,58.9h-1.9v-8.1h1.9V58.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_143_",
    className: "st0",
    d: "M149.9,50.9c0.1,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0.1c0,0,0.1,0.1,0.1,0.1l3.8,4.8 c0-0.2,0-0.3,0-0.5c0-0.1,0-0.3,0-0.4v-4.3h1.6v8.1h-1c-0.1,0-0.3,0-0.4-0.1c-0.1,0-0.2-0.1-0.3-0.2l-3.8-4.8c0,0.1,0,0.3,0,0.4 c0,0.1,0,0.3,0,0.4v4.3h-1.6v-8.1h1C149.8,50.9,149.8,50.9,149.9,50.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_145_",
    className: "st0",
    d: "M162.5,52.5c-0.1,0.1-0.1,0.2-0.2,0.2c-0.1,0-0.1,0.1-0.2,0.1c-0.1,0-0.2,0-0.3-0.1 c-0.1-0.1-0.2-0.1-0.3-0.2c-0.1-0.1-0.3-0.1-0.4-0.2c-0.2-0.1-0.3-0.1-0.5-0.1c-0.3,0-0.6,0.1-0.8,0.2c-0.2,0.1-0.3,0.4-0.3,0.6 c0,0.2,0.1,0.3,0.2,0.4c0.1,0.1,0.2,0.2,0.4,0.3c0.2,0.1,0.4,0.1,0.6,0.2c0.2,0.1,0.4,0.1,0.7,0.2c0.2,0.1,0.4,0.2,0.7,0.3 c0.2,0.1,0.4,0.2,0.6,0.4c0.2,0.2,0.3,0.4,0.4,0.6c0.1,0.2,0.2,0.5,0.2,0.9c0,0.4-0.1,0.7-0.2,1s-0.3,0.6-0.6,0.8 c-0.2,0.2-0.5,0.4-0.9,0.6c-0.4,0.1-0.8,0.2-1.2,0.2c-0.3,0-0.5,0-0.8-0.1c-0.3-0.1-0.5-0.1-0.8-0.2c-0.2-0.1-0.5-0.2-0.7-0.3 c-0.2-0.1-0.4-0.3-0.6-0.4l0.6-0.9c0-0.1,0.1-0.1,0.2-0.2c0.1,0,0.2-0.1,0.2-0.1c0.1,0,0.2,0,0.3,0.1c0.1,0.1,0.2,0.1,0.4,0.2 c0.1,0.1,0.3,0.2,0.5,0.2c0.2,0.1,0.4,0.1,0.7,0.1c0.3,0,0.6-0.1,0.8-0.2c0.2-0.1,0.3-0.4,0.3-0.7c0-0.2-0.1-0.3-0.2-0.5 c-0.1-0.1-0.2-0.2-0.4-0.3c-0.2-0.1-0.4-0.1-0.6-0.2c-0.2-0.1-0.4-0.1-0.7-0.2c-0.2-0.1-0.4-0.2-0.7-0.3c-0.2-0.1-0.4-0.2-0.6-0.4 c-0.2-0.2-0.3-0.4-0.4-0.6c-0.1-0.3-0.2-0.6-0.2-0.9c0-0.3,0.1-0.6,0.2-0.9c0.1-0.3,0.3-0.5,0.5-0.8c0.2-0.2,0.5-0.4,0.9-0.5 c0.3-0.1,0.7-0.2,1.2-0.2c0.2,0,0.5,0,0.7,0.1c0.2,0,0.5,0.1,0.7,0.2c0.2,0.1,0.4,0.2,0.6,0.3c0.2,0.1,0.3,0.2,0.5,0.4L162.5,52.5 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_147_",
    className: "st0",
    d: "M170.9,50.9v1.5h-2.3v6.6h-1.9v-6.6h-2.3v-1.5H170.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_149_",
    className: "st0",
    d: "M174.7,58.9h-1.9v-8.1h1.9V58.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_151_",
    className: "st0",
    d: "M183,50.9v1.5h-2.3v6.6h-1.9v-6.6h-2.3v-1.5H183z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_153_",
    className: "st0",
    d: "M188.1,57.4c0.3,0,0.5,0,0.7-0.1c0.2-0.1,0.4-0.2,0.5-0.4c0.1-0.2,0.2-0.3,0.3-0.6 c0.1-0.2,0.1-0.5,0.1-0.8v-4.8h1.9v4.8c0,0.5-0.1,0.9-0.2,1.4c-0.2,0.4-0.4,0.8-0.7,1.1c-0.3,0.3-0.7,0.5-1.1,0.7 c-0.4,0.2-0.9,0.2-1.4,0.2c-0.5,0-1-0.1-1.4-0.2c-0.4-0.2-0.8-0.4-1.1-0.7c-0.3-0.3-0.5-0.7-0.7-1.1c-0.2-0.4-0.2-0.9-0.2-1.4 v-4.8h1.9v4.8c0,0.3,0,0.5,0.1,0.8s0.2,0.4,0.3,0.6c0.1,0.2,0.3,0.3,0.5,0.4C187.6,57.4,187.9,57.4,188.1,57.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_155_",
    className: "st0",
    d: "M199.6,50.9v1.5h-2.3v6.6h-1.9v-6.6h-2.3v-1.5H199.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_157_",
    className: "st0",
    d: "M206.6,50.9v1.4h-3.3v1.9h2.5v1.4h-2.5v1.9h3.3v1.4h-5.2v-8.1H206.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_15_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_98_",
    className: "st0",
    d: "M207.5,5.2c0-0.3,0-0.7,0.1-1c0.1-0.3,0.2-0.6,0.4-0.9s0.4-0.5,0.6-0.8 c0.2-0.2,0.5-0.4,0.8-0.6c0.3-0.2,0.6-0.3,0.9-0.4c0.3-0.1,0.6-0.1,1-0.1s0.7,0,1,0.1c0.3,0.1,0.6,0.2,0.9,0.4 c0.3,0.2,0.5,0.4,0.8,0.6c0.2,0.2,0.4,0.5,0.6,0.8s0.3,0.6,0.4,0.9c0.1,0.3,0.1,0.6,0.1,1c0,0.3,0,0.7-0.1,1 c-0.1,0.3-0.2,0.6-0.4,0.9c-0.2,0.3-0.4,0.5-0.6,0.8c-0.2,0.2-0.5,0.4-0.8,0.6c-0.3,0.2-0.6,0.3-0.9,0.4c-0.3,0.1-0.6,0.1-1,0.1 s-0.7,0-1-0.1c-0.3-0.1-0.6-0.2-0.9-0.4c-0.3-0.2-0.5-0.4-0.8-0.6s-0.4-0.5-0.6-0.8c-0.2-0.3-0.3-0.6-0.4-0.9 C207.6,5.9,207.5,5.6,207.5,5.2z M208.1,5.2c0,0.3,0,0.6,0.1,0.9c0.1,0.3,0.2,0.5,0.3,0.8c0.1,0.2,0.3,0.5,0.5,0.7 c0.2,0.2,0.4,0.4,0.6,0.5c0.2,0.1,0.5,0.3,0.8,0.3c0.3,0.1,0.6,0.1,0.9,0.1c0.4,0,0.9-0.1,1.3-0.3c0.4-0.2,0.7-0.4,1-0.7 c0.3-0.3,0.5-0.6,0.7-1c0.2-0.4,0.3-0.8,0.3-1.3c0-0.3,0-0.6-0.1-0.9c-0.1-0.3-0.2-0.5-0.3-0.8c-0.1-0.2-0.3-0.5-0.5-0.7 c-0.2-0.2-0.4-0.4-0.7-0.5c-0.2-0.1-0.5-0.3-0.8-0.3c-0.3-0.1-0.6-0.1-0.9-0.1c-0.4,0-0.9,0.1-1.3,0.3c-0.4,0.2-0.7,0.4-1,0.7 c-0.3,0.3-0.5,0.6-0.7,1C208.1,4.3,208.1,4.8,208.1,5.2z M210.5,5.7v1.8h-0.8V2.9h1.5c0.6,0,1,0.1,1.3,0.3 c0.3,0.2,0.4,0.5,0.4,0.9c0,0.3-0.1,0.6-0.3,0.8c-0.2,0.2-0.5,0.4-0.8,0.5c0.1,0,0.1,0.1,0.2,0.1c0,0.1,0.1,0.1,0.1,0.2l1.2,1.7 h-0.8c-0.1,0-0.2,0-0.2-0.1l-1-1.5c0,0-0.1-0.1-0.1-0.1c0,0-0.1,0-0.2,0H210.5z M210.5,5.1h0.6c0.2,0,0.3,0,0.5-0.1 c0.1,0,0.2-0.1,0.3-0.2c0.1-0.1,0.1-0.2,0.2-0.3c0-0.1,0.1-0.2,0.1-0.3c0-0.1,0-0.2,0-0.3c0-0.1-0.1-0.2-0.2-0.2 c-0.1-0.1-0.2-0.1-0.3-0.1c-0.1,0-0.3,0-0.4,0h-0.7V5.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_16_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3_",
    className: "st0",
    d: "M25.8,4.4h-2l-0.4,1.1h-1.2l2-5.5h1l2.1,5.5h-1.2L25.8,4.4z M24.1,3.5h1.4l-0.7-2.1L24.1,3.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9_",
    className: "st0",
    d: "M32.9,5.6h-1.1L29.6,2v3.6h-1.1V0.1h1.1l2.2,3.6V0.1h1.1V5.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_11_",
    className: "st0",
    d: "M38.1,5.6H37V0.1h1.1V5.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_21_",
    className: "st0",
    d: "M42.5,4.1c0-0.2-0.1-0.4-0.2-0.5c-0.2-0.1-0.4-0.2-0.8-0.4c-0.4-0.1-0.7-0.3-0.9-0.4 c-0.6-0.3-0.9-0.8-0.9-1.4c0-0.3,0.1-0.6,0.3-0.8s0.4-0.4,0.7-0.5C40.9,0.1,41.2,0,41.6,0c0.4,0,0.7,0.1,1,0.2 c0.3,0.1,0.5,0.3,0.7,0.6c0.2,0.3,0.3,0.6,0.3,0.9h-1.1c0-0.3-0.1-0.4-0.2-0.6c-0.2-0.1-0.4-0.2-0.7-0.2c-0.3,0-0.5,0.1-0.6,0.2 c-0.2,0.1-0.2,0.3-0.2,0.5c0,0.2,0.1,0.3,0.3,0.4s0.4,0.2,0.8,0.3c0.6,0.2,1.1,0.4,1.4,0.7c0.3,0.3,0.4,0.6,0.4,1.1 c0,0.5-0.2,0.8-0.5,1.1c-0.4,0.3-0.8,0.4-1.4,0.4c-0.4,0-0.8-0.1-1.2-0.2c-0.3-0.2-0.6-0.4-0.8-0.6c-0.2-0.3-0.3-0.6-0.3-0.9h1.1 c0,0.6,0.4,0.9,1.1,0.9c0.3,0,0.5-0.1,0.6-0.2C42.4,4.5,42.5,4.3,42.5,4.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_25_",
    className: "st0",
    d: "M49.5,2.9c0,0.5-0.1,1-0.3,1.4c-0.2,0.4-0.5,0.7-0.8,0.9c-0.4,0.2-0.8,0.3-1.2,0.3 c-0.5,0-0.9-0.1-1.2-0.3c-0.4-0.2-0.6-0.5-0.8-0.9C44.9,4,44.8,3.5,44.8,3V2.7c0-0.5,0.1-1,0.3-1.4c0.2-0.4,0.5-0.7,0.8-0.9 C46.3,0.1,46.7,0,47.1,0c0.5,0,0.9,0.1,1.2,0.3c0.4,0.2,0.6,0.5,0.8,0.9c0.2,0.4,0.3,0.9,0.3,1.4V2.9z M48.3,2.7 c0-0.6-0.1-1-0.3-1.3s-0.5-0.4-0.9-0.4c-0.4,0-0.7,0.1-0.9,0.4c-0.2,0.3-0.3,0.7-0.3,1.3v0.3c0,0.6,0.1,1,0.3,1.3 c0.2,0.3,0.5,0.5,0.9,0.5c0.4,0,0.7-0.1,0.9-0.4C48.2,4,48.3,3.5,48.3,3V2.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_32_",
    className: "st0",
    d: "M55.7,3.4c-0.3,0.3-0.6,0.4-1,0.4c-0.5,0-0.9-0.2-1.2-0.5s-0.4-0.8-0.4-1.3 c0-0.4,0.1-0.7,0.2-1c0.2-0.3,0.4-0.5,0.7-0.7C54.3,0.1,54.6,0,55,0c0.4,0,0.7,0.1,1,0.3c0.3,0.2,0.5,0.4,0.7,0.8 c0.2,0.3,0.2,0.7,0.2,1.2v0.4c0,0.9-0.2,1.6-0.7,2.2c-0.5,0.5-1.1,0.8-1.9,0.8l-0.3,0V4.7l0.2,0C55.1,4.7,55.6,4.2,55.7,3.4z  M55,3c0.2,0,0.3,0,0.5-0.1c0.1-0.1,0.2-0.2,0.3-0.3V2c0-0.4-0.1-0.7-0.2-0.9c-0.1-0.2-0.3-0.3-0.6-0.3c-0.2,0-0.4,0.1-0.5,0.3 c-0.1,0.2-0.2,0.5-0.2,0.8c0,0.3,0.1,0.5,0.2,0.7C54.5,2.9,54.7,3,55,3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_36_",
    className: "st0",
    d: "M61.8,3.3c0,0.8-0.2,1.3-0.5,1.7C61,5.4,60.6,5.6,60,5.6c-0.6,0-1.1-0.2-1.4-0.6 c-0.3-0.4-0.5-1-0.5-1.7v-1c0-0.8,0.2-1.3,0.5-1.7C58.9,0.2,59.4,0,60,0c0.6,0,1.1,0.2,1.4,0.6s0.5,1,0.5,1.7V3.3z M60.7,2.2 c0-0.5-0.1-0.8-0.2-1C60.4,1,60.2,0.9,60,0.9c-0.3,0-0.4,0.1-0.6,0.3s-0.2,0.5-0.2,0.9v1.3c0,0.4,0.1,0.8,0.2,1 c0.1,0.2,0.3,0.3,0.6,0.3c0.3,0,0.5-0.1,0.6-0.3c0.1-0.2,0.2-0.5,0.2-1V2.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_39_",
    className: "st0",
    d: "M66.8,3.3c0,0.8-0.2,1.3-0.5,1.7c-0.3,0.4-0.8,0.6-1.4,0.6c-0.6,0-1.1-0.2-1.4-0.6 c-0.3-0.4-0.5-1-0.5-1.7v-1c0-0.8,0.2-1.3,0.5-1.7C63.9,0.2,64.3,0,64.9,0c0.6,0,1.1,0.2,1.4,0.6c0.3,0.4,0.5,1,0.5,1.7V3.3z  M65.7,2.2c0-0.5-0.1-0.8-0.2-1c-0.1-0.2-0.3-0.3-0.6-0.3c-0.3,0-0.4,0.1-0.6,0.3c-0.1,0.2-0.2,0.5-0.2,0.9v1.3 c0,0.4,0.1,0.8,0.2,1c0.1,0.2,0.3,0.3,0.6,0.3c0.3,0,0.5-0.1,0.6-0.3c0.1-0.2,0.2-0.5,0.2-1V2.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_45_",
    className: "st0",
    d: "M70.7,5.6h-1.1V1.4l-1.3,0.4V0.9l2.3-0.8h0.1V5.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_47_",
    className: "st0",
    d: "M73.1,1.9c0-0.2,0.1-0.3,0.2-0.4c0.1-0.1,0.3-0.2,0.4-0.2c0.2,0,0.3,0.1,0.4,0.2 c0.1,0.1,0.2,0.2,0.2,0.4c0,0.2-0.1,0.3-0.2,0.4c-0.1,0.1-0.3,0.2-0.4,0.2c-0.2,0-0.3-0.1-0.4-0.2C73.2,2.2,73.1,2.1,73.1,1.9z  M73.1,5c0-0.2,0.1-0.3,0.2-0.4c0.1-0.1,0.3-0.2,0.4-0.2c0.2,0,0.3,0.1,0.4,0.2c0.1,0.1,0.2,0.2,0.2,0.4c0,0.2-0.1,0.3-0.2,0.4 c-0.1,0.1-0.3,0.2-0.4,0.2c-0.2,0-0.3-0.1-0.4-0.2C73.2,5.3,73.1,5.2,73.1,5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_50_",
    className: "st0",
    d: "M79.5,5.6h-3.8V4.8l1.8-1.9c0.2-0.3,0.4-0.5,0.5-0.7c0.1-0.2,0.2-0.4,0.2-0.6 c0-0.2-0.1-0.4-0.2-0.6c-0.1-0.1-0.3-0.2-0.5-0.2c-0.2,0-0.4,0.1-0.6,0.3c-0.1,0.2-0.2,0.4-0.2,0.7h-1.1c0-0.3,0.1-0.6,0.2-0.9 c0.2-0.3,0.4-0.5,0.7-0.6c0.3-0.2,0.6-0.2,1-0.2c0.6,0,1,0.1,1.3,0.4c0.3,0.3,0.5,0.7,0.5,1.1c0,0.3-0.1,0.5-0.2,0.8 c-0.1,0.3-0.4,0.6-0.7,1l-1.2,1.3h2.4V5.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_52_",
    className: "st0",
    d: "M84.4,3.3c0,0.8-0.2,1.3-0.5,1.7c-0.3,0.4-0.8,0.6-1.4,0.6c-0.6,0-1.1-0.2-1.4-0.6 c-0.3-0.4-0.5-1-0.5-1.7v-1c0-0.8,0.2-1.3,0.5-1.7C81.5,0.2,81.9,0,82.5,0c0.6,0,1.1,0.2,1.4,0.6c0.3,0.4,0.5,1,0.5,1.7V3.3z  M83.3,2.2c0-0.5-0.1-0.8-0.2-1C83,1,82.8,0.9,82.5,0.9c-0.3,0-0.4,0.1-0.6,0.3s-0.2,0.5-0.2,0.9v1.3c0,0.4,0.1,0.8,0.2,1 c0.1,0.2,0.3,0.3,0.6,0.3c0.3,0,0.5-0.1,0.6-0.3c0.1-0.2,0.2-0.5,0.2-1V2.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_55_",
    className: "st0",
    d: "M88.3,5.6h-1.1V1.4l-1.3,0.4V0.9l2.3-0.8h0.1V5.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_57_",
    className: "st0",
    d: "M90.8,2.9l0.3-2.8h3.1V1H92l-0.1,1.2C92.1,2,92.4,2,92.7,2c0.5,0,0.9,0.2,1.2,0.5 c0.3,0.3,0.4,0.8,0.4,1.4c0,0.4-0.1,0.7-0.2,1C94,5,93.8,5.2,93.5,5.4s-0.6,0.2-1,0.2c-0.3,0-0.6-0.1-0.9-0.2 c-0.3-0.1-0.5-0.3-0.7-0.6c-0.2-0.2-0.3-0.5-0.3-0.8h1.1c0,0.2,0.1,0.4,0.2,0.5c0.1,0.1,0.3,0.2,0.5,0.2c0.2,0,0.4-0.1,0.6-0.3 c0.1-0.2,0.2-0.4,0.2-0.8c0-0.3-0.1-0.6-0.2-0.7c-0.2-0.2-0.4-0.2-0.7-0.2c-0.3,0-0.5,0.1-0.6,0.2l-0.1,0.1L90.8,2.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_59_",
    className: "st0",
    d: "M102.5,3.7c0,0.6-0.3,1.1-0.7,1.4c-0.4,0.3-0.9,0.5-1.6,0.5c-0.7,0-1.3-0.2-1.7-0.7 C98.2,4.5,98,3.8,98,3V2.6c0-0.5,0.1-1,0.3-1.4c0.2-0.4,0.5-0.7,0.8-0.9c0.3-0.2,0.7-0.3,1.2-0.3c0.6,0,1.1,0.2,1.5,0.5 c0.4,0.3,0.6,0.8,0.7,1.4h-1.1c0-0.4-0.1-0.6-0.3-0.8c-0.2-0.2-0.4-0.2-0.8-0.2c-0.4,0-0.7,0.1-0.8,0.4c-0.2,0.3-0.3,0.7-0.3,1.3 V3c0,0.6,0.1,1,0.3,1.3c0.2,0.3,0.5,0.4,0.8,0.4c0.3,0,0.6-0.1,0.8-0.2c0.2-0.2,0.3-0.4,0.3-0.7H102.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_62_",
    className: "st0",
    d: "M107,3.2h-2.2v1.5h2.5v0.9h-3.7V0.1h3.7V1h-2.5v1.3h2.2V3.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_64_",
    className: "st0",
    d: "M110.6,3.6h-0.9v2h-1.1V0.1h2c0.6,0,1.1,0.1,1.5,0.4c0.4,0.3,0.5,0.7,0.5,1.2 c0,0.4-0.1,0.7-0.2,0.9c-0.2,0.2-0.4,0.4-0.7,0.6l1.2,2.2v0.1h-1.2L110.6,3.6z M109.7,2.6h0.9c0.3,0,0.5-0.1,0.7-0.2 c0.2-0.1,0.2-0.3,0.2-0.6c0-0.3-0.1-0.5-0.2-0.6C111.2,1.1,111,1,110.6,1h-0.9V2.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_67_",
    className: "st0",
    d: "M118,1h-1.7v4.6h-1.1V1h-1.7V0.1h4.5V1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_69_",
    className: "st0",
    d: "M120.4,5.6h-1.1V0.1h1.1V5.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_71_",
    className: "st0",
    d: "M125.3,3.3h-2.2v2.2H122V0.1h3.6V1h-2.4v1.4h2.2V3.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_73_",
    className: "st0",
    d: "M127.9,5.6h-1.1V0.1h1.1V5.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_75_",
    className: "st0",
    d: "M132.8,3.2h-2.2v1.5h2.5v0.9h-3.7V0.1h3.7V1h-2.5v1.3h2.2V3.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_77_",
    className: "st0",
    d: "M134.4,5.6V0.1h1.7c0.5,0,0.9,0.1,1.3,0.3c0.4,0.2,0.7,0.5,0.9,0.9c0.2,0.4,0.3,0.9,0.3,1.4 v0.3c0,0.5-0.1,1-0.3,1.4c-0.2,0.4-0.5,0.7-0.9,0.9c-0.4,0.2-0.8,0.3-1.3,0.3H134.4z M135.5,1v3.7h0.5c0.4,0,0.8-0.1,1-0.4 c0.2-0.3,0.4-0.7,0.4-1.2V2.7c0-0.6-0.1-1-0.3-1.3c-0.2-0.3-0.6-0.4-1-0.4H135.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_80_",
    className: "st0",
    d: "M143.6,5.6h-1.1V0.1h1.1V5.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_82_",
    className: "st0",
    d: "M149.7,5.6h-1.1L146.3,2v3.6h-1.1V0.1h1.1l2.2,3.6V0.1h1.1V5.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_84_",
    className: "st0",
    d: "M154,4.1c0-0.2-0.1-0.4-0.2-0.5c-0.2-0.1-0.4-0.2-0.8-0.4c-0.4-0.1-0.7-0.3-0.9-0.4 c-0.6-0.3-0.9-0.8-0.9-1.4c0-0.3,0.1-0.6,0.3-0.8c0.2-0.2,0.4-0.4,0.7-0.5c0.3-0.1,0.7-0.2,1.1-0.2c0.4,0,0.7,0.1,1,0.2 s0.5,0.3,0.7,0.6c0.2,0.3,0.3,0.6,0.3,0.9H154c0-0.3-0.1-0.4-0.2-0.6c-0.2-0.1-0.4-0.2-0.7-0.2c-0.3,0-0.5,0.1-0.6,0.2 c-0.2,0.1-0.2,0.3-0.2,0.5c0,0.2,0.1,0.3,0.3,0.4c0.2,0.1,0.4,0.2,0.8,0.3c0.6,0.2,1.1,0.4,1.4,0.7c0.3,0.3,0.4,0.6,0.4,1.1 c0,0.5-0.2,0.8-0.5,1.1c-0.4,0.3-0.8,0.4-1.4,0.4c-0.4,0-0.8-0.1-1.2-0.2s-0.6-0.4-0.8-0.6C151,4.5,151,4.2,151,3.8h1.1 c0,0.6,0.4,0.9,1.1,0.9c0.3,0,0.5-0.1,0.6-0.2C153.9,4.5,154,4.3,154,4.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_86_",
    className: "st0",
    d: "M160.6,1h-1.7v4.6h-1.1V1h-1.7V0.1h4.5V1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_88_",
    className: "st0",
    d: "M163,5.6h-1.1V0.1h1.1V5.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_90_",
    className: "st0",
    d: "M168.6,1h-1.7v4.6h-1.1V1h-1.7V0.1h4.5V1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_92_",
    className: "st0",
    d: "M173.9,0.1v3.6c0,0.6-0.2,1.1-0.6,1.4c-0.4,0.3-0.9,0.5-1.5,0.5c-0.6,0-1.1-0.2-1.5-0.5 c-0.4-0.3-0.6-0.8-0.6-1.4V0.1h1.1v3.6c0,0.4,0.1,0.6,0.3,0.8c0.2,0.2,0.4,0.2,0.7,0.2c0.6,0,1-0.3,1-1V0.1H173.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_94_",
    className: "st0",
    d: "M179.5,1h-1.7v4.6h-1.1V1H175V0.1h4.5V1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_96_",
    className: "st0",
    d: "M184,3.2h-2.2v1.5h2.5v0.9h-3.7V0.1h3.7V1h-2.5v1.3h2.2V3.2z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.ae029640f83c6c157b63ea5e68f3e8e0.svg";
export { ForwardRef as ReactComponent };